import { handleActions } from 'redux-actions';
import type {
  BoostInitializationStoreSlice,
  NetworkRequestStatus,
} from '../types';
import {
  initialize,
  initializeSuccess,
  initializeError,
  deinitialize,
  setSelectedDuration,
} from '../actions';
import { reduxKey } from '../constants';

const initialState: BoostInitializationStoreSlice = {
  requestStatus: 'idle' as NetworkRequestStatus,
  requestError: undefined,
  isInitialized: false,
  deviation: undefined,
  tags: [],
  recommendedTags: [],
  selectedDuration: 2,
};

const actionHandlers = handleActions<BoostInitializationStoreSlice, any>(
  {
    [`${initialize}`]: (state, action: ReturnType<typeof initialize>) => ({
      ...state,
      requestStatus: 'fetching' as NetworkRequestStatus,
      requestError: undefined,
    }),
    [`${initializeSuccess}`]: (
      state,
      action: ReturnType<typeof initializeSuccess>
    ) => ({
      ...state,
      requestStatus: 'success' as NetworkRequestStatus,
      requestError: undefined,
      isInitialized: true,
      deviation: action.payload.deviation,
      tags: action.payload.tags,
      recommendedTags: action.payload.recommendedTags,
    }),
    [`${initializeError}`]: (
      state,
      action: ReturnType<typeof initializeError>
    ) => ({
      ...state,
      requestStatus: 'error' as NetworkRequestStatus,
      requestError: action.payload.errorMessage,
    }),

    [`${deinitialize}`]: (state, action: ReturnType<typeof deinitialize>) => ({
      ...state,
      requestStatus: 'idle' as NetworkRequestStatus,
      requestError: undefined,
      isInitialized: false,
      deviation: undefined,
      tags: [],
      recommendedTags: [],
    }),

    [`${setSelectedDuration}`]: (
      state,
      action: ReturnType<typeof setSelectedDuration>
    ) => ({
      ...state,
      selectedDuration: action.payload.duration,
    }),
  },
  {
    ...initialState,
  }
);

const reducers = {
  [reduxKey as string]: actionHandlers,
};

export const boostReducer = actionHandlers;
export default reducers;
